import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SvgIconModule } from '../../components/svg-icon';

import { ContenteditableModelDirective } from './contenteditable-model.directive';
import { CmsEditorComponent } from './cms-editor.component';
import { UploadMediaModule } from '../../components/upload-media/upload-media.module';
import { UploadCropperModule } from '../../components/upload-cropper/upload-cropper.module';

@NgModule({
    declarations: [
        CmsEditorComponent,
        ContenteditableModelDirective
    ],
    imports: [
        CommonModule,
        SvgIconModule,
        UploadMediaModule,
        UploadCropperModule
    ],
    exports: [
        CmsEditorComponent,
        ContenteditableModelDirective
    ]
})
export class CmsEditorModule { }
